import React, { useState } from "react";
import { Modal, Form } from "react-bootstrap";
import CommonButton from "../commonButton";
import withModal from "../withModal";
import InputField from "../form/InputField";
import CustomSelect from "../form/CustomSelect";

const RejectDocumentModalInner = ({ onClose, onReject }) => {
    const [reason, setReason] = useState("Document Not Clear");
    const [comment, setComment] = useState("");

    const handleRejectClick = () => {
        onReject(reason);
    };

    return (
        <Form onSubmit={(e) => e.preventDefault()}>
            <Modal.Body className="padding-30">
                <CustomSelect
                    className="mb-4"
                    label={{ name: "Reason :" }}
                    value={reason}
                    onChange={(name, val) => setReason(val)}
                    options={[
                        { value: "Document Not Clear", label: "Document Not Clear" },
                        { value: "Invalid Document", label: "Invalid Document" },
                        { value: "Expired Document", label: "Expired Document" },
                    ]}
                    isSearchable={false}
                />

                <InputField
                    className="mb-4"
                    label={{ name: "Add Comments", class: "sub-text mb-2" }}
                    input={{
                        as: "textarea",
                        rows: 4,
                        placeholder: "Optional",
                        className: "shadow-none",
                        style: { resize: "none" },
                        value: comment,
                        onChange: (e) => setComment(e.target.value),
                    }}
                />
            </Modal.Body>
            <Modal.Footer>
                <CommonButton
                    type="button"
                    title="Cancel"
                    variant="outline-primary"
                    onClick={onClose}
                />
                <CommonButton
                    type="button"
                    title="Reject Document"
                    variant="primary"
                    onClick={handleRejectClick}
                />
            </Modal.Footer>
        </Form>
    );
};

const RejectDocumentModal = withModal(RejectDocumentModalInner);

export default RejectDocumentModal;